module.exports = __webpack_public_path__ + "static/media/Retreats-06.b927b742.webp";